/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { LOCAL_STORAGE, setDataSession } from "../../helper/session";
import { CURRENT_BIZZAPP, setCurrentBizzApp } from "../../redux/bizzAppReducer";
import { PRIMARY, WHITE } from "../../theme/colors";
// import CoreDialog from "../components/common/CoreDialog";
import { useSelector } from "react-redux";
import { ReactComponent as Arrows } from "../../assets/svg/arrows.svg";
import { getUserSession } from "../../helper/user";
import {
  getProductUser,
  getListProduct,
} from "../../modules/UAA/page/CreateUpdateUser/service/createUpdateService";
import { useNavigate } from "react-router";
import DefaultImageApp from "../../assets/png/customer.png";
import useGetImage from "./useGetImage";
import LoadingPage from "../components/common/LoadingPage";

const BizzAppBox = (props) => {
  const { item, handleChangeBizzApp } = props;
  const { handleGetUrlImage, urlImage, loadingImage } = useGetImage();

  useEffect(() => {
    item?.imageUrl && handleGetUrlImage(item?.imageUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  return (
    <Box
      className="flex flex-col items-center"
      sx={{
        ":hover": {
          cursor: "pointer",
        },
      }}
      onClick={() => handleChangeBizzApp(item)}
    >
      {loadingImage ? (
        <div className="relative w-75 h-75">
          <LoadingPage />
        </div>
      ) : (
        <img
          width="150px"
          height="150px"
          style={{ objectFit: "cover", borderRadius: 8 }}
          src={item?.imageUrl ? urlImage : DefaultImageApp}
          alt={item?.name}
        />
      )}

      <Typography className="mt-8">{item?.name}</Typography>
    </Box>
  );
};

export const useChangeBizzApp = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);
  const [totalListBizz, setTotalBizzList] = useState();
  const { currentBizzApp } = useSelector((state) => state.bizzApps);
  const navigate = useNavigate();

  const handleChangeBizzApp = useCallback(
    (bizzApp) => {
      setDataSession(LOCAL_STORAGE, CURRENT_BIZZAPP, bizzApp);
      dispatch(setCurrentBizzApp(bizzApp));

      if (open) {
        handleCloseDialog();
        navigate("/");
      }
    },
    [dispatch, navigate, open]
  );
  const { t } = useTranslation("common");
  const userInfo = getUserSession();

  const isSystemAdmin = userInfo?.roles?.some(
    (item) => item.alias === "SYSTEM_ADMIN"
  );

  const getCurrentUserRole = async (userId) => {
    try {
      const res = await getProductUser({ userId });
      const res2 = await getListProduct();
      if (isSystemAdmin) {
        setTotalBizzList(
          res2?.data?.data?.content.filter((v) => v.isActivated)
        );
      } else setTotalBizzList(res?.data?.data.filter((v) => v.isActivated));
    } catch (err) {}
  };

  const renderDialogChoseBizzApp = () => {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ className: "rounded-lg", style: { overflow: "inherit" } }}
      >
        <DialogTitle
          style={{
            backgroundColor: PRIMARY,
            color: WHITE,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
          className="relative"
        >
          <Box>
            <Box
              className="flex justify-center w-full"
              style={{ position: "absolute", top: "-50%", left: 0, right: 0 }}
            >
              <Box className="bg-white rounded-full p-10">
                <Arrows />
              </Box>
            </Box>
          </Box>

          <Typography
            className="font-sans uppercase font-medium text-center mt-20"
            variant="h5"
          >
            {t("bizzapp.label")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box className="grid grid-cols-3 gap-15 mx-10 my-20">
            {totalListBizz?.map((item, index) => {
              return (
                <BizzAppBox
                  item={item}
                  key={index}
                  handleChangeBizzApp={handleChangeBizzApp}
                />
              );
            })}
          </Box>
        </DialogContent>
      </Dialog>
    );
  };
  useEffect(() => {
    getCurrentUserRole(userInfo?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.id, open]);

  useEffect(() => {
    if (!currentBizzApp && totalListBizz?.length > 0) {
      handleChangeBizzApp(totalListBizz[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBizzApp, totalListBizz]);

  return { renderDialogChoseBizzApp, handleOpenDialog, handleCloseDialog };
};
